import styled from 'styled-components';
import StyledModal from '../Modal/styled';
import COLORS from '../../../constants/COLORS';

export default {
  Wrapper: styled.div`
    ${StyledModal.Container} {
      padding: 24px;
    }
  `,

  Title: styled.div`
    padding-right: 18px;
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 24px;
    line-height: 34px;
    color: ${COLORS.MARKETPLACE_BLACK};
  `,

  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    line-height: 26px;
    color: ${COLORS.MARKETPLACE_BLACK};
  `,

  Ticket: styled.div`
    margin-bottom: 8px;
  `,

  ItemPrice: styled.div`
    font-size: 16px;
    font-weight: bold;
  `,

  Footer: styled.div`
    margin: 24px -24px -24px;
    padding: 10px 24px;
    background: ${COLORS.MARKETPLACE_GREY};
    border-radius: 0px 0px 12px 12px;
    color: ${COLORS.MARKETPLACE_DARK_GREY};
  `,

  Price: styled.span<{ dark: boolean }>`
    margin-left: 4px;
    font-weight: 500;
    font-size: 14px;
    color: ${(prps) => (prps.dark ? COLORS.MARKETPLACE_BLACK : COLORS.MARKETPLACE_DARK_GREY)};
  `,
};
